import {
    SET_SAVED_CANDIDATES_LOADING,
    SET_SAVED_CANDIDATES_ERROR,

    FETCH_SAVED_CANDIDATES_BY_DEMANDE_SUCCESS,
    FETCH_SAVED_CANDIDATES_BY_DEMANDE_FAIL,

    SAVE_CANDIDATE_FOR_DEMANDE_FAIL,

    UNSAVE_CANDIDATE_FOR_DEMANDE_SUCCESS,
    UNSAVE_CANDIDATE_FOR_DEMANDE_FAIL,
} from "../actions/demandeCandidatSauvegardeActions";

const initialState = {
    loading: false,
    error: null,
    savedCandidates: [],
};

export default function demandeCandidatSauvegardeReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SAVED_CANDIDATES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_SAVED_CANDIDATES_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case FETCH_SAVED_CANDIDATES_BY_DEMANDE_SUCCESS:
            return {
                ...state,
                savedCandidates: action.payload || [],
                error: null,
            };

        case UNSAVE_CANDIDATE_FOR_DEMANDE_SUCCESS:
            return {
                ...state,
                savedCandidates: state.savedCandidates.filter(
                    (item) => !(
                        Number(item.demandeId) === Number(action.payload.demandeId) &&
                        Number(item.candidatId) === Number(action.payload.candidatId)
                    )
                ),
                error: null,
            };

        case FETCH_SAVED_CANDIDATES_BY_DEMANDE_FAIL:
        case SAVE_CANDIDATE_FOR_DEMANDE_FAIL:
        case UNSAVE_CANDIDATE_FOR_DEMANDE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
}